import { Organization } from "@common/types/organization";
import { OrganizationDtoSchema } from "@common/schemas/organization.schema";
import { WorkspaceMember, WorkspaceMemberBase } from "../../types/workspace";
import { UserDto } from "../user/user.dto";
import { UserWorkspaceRole } from "../../userWorkspaceRoles";
import { WorkspaceMemberEntityAssignmentDto } from "./workspace-member-entity-assignment.dto";

export class WorkspaceMemberDto {
    static deserialize(dto: WorkspaceMemberDto): WorkspaceMember {
        return {
            user: UserDto.deserialize(dto.user),
            role: dto.role,
            entityAssignments: dto.entityAssignments.map(
                WorkspaceMemberEntityAssignmentDto.deserialize,
            ),
            assignToNewEntities: dto.assignToNewEntities,
            organizationId: dto.organizationId,
            organization: dto.organization
                ? OrganizationDtoSchema.parse(dto.organization)
                : null,
        };
    }

    user: UserDto;
    role: UserWorkspaceRole;
    entityAssignments: WorkspaceMemberEntityAssignmentDto[];
    assignToNewEntities: boolean;
    organizationId: string | null;
    organization: Organization | null;

    constructor(member: WorkspaceMemberBase) {
        this.user = new UserDto(member.user);
        this.role = member.role;
        this.entityAssignments = member.entityAssignments.map(
            (ea) => new WorkspaceMemberEntityAssignmentDto(ea),
        );
        this.assignToNewEntities = member.assignToNewEntities;
        this.organizationId = member.organizationId;
        this.organization = member.organization ?? null;
    }
}
